// RDP Collection — Reveal animations & filter toggle
(function () {
  'use strict';

  // ── Reveal on scroll ──
  const revealEls = document.querySelectorAll('.rdp-reveal');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach((el) => observer.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  // ── Filter panel toggle ──
  const filterToggle = document.querySelector('.rdp-col-controls__filter-toggle');
  const filterPanel = document.getElementById('rdp-filter-panel');

  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => {
      const isOpen = filterPanel.hasAttribute('hidden') === false;
      if (isOpen) {
        filterPanel.setAttribute('hidden', '');
        filterToggle.setAttribute('aria-expanded', 'false');
      } else {
        filterPanel.removeAttribute('hidden');
        filterToggle.setAttribute('aria-expanded', 'true');
      }
    });
  }
})();
